import React from 'react';
import { useComponentTheme } from '@chegg-ui/theme';
import { isItemWithSublist } from '../shared';
import { getThemeConfig, ListUl, ListLi, ListItemContent } from '../styles';

var List = function List(_ref) {
  var items = _ref.items,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'dark' : _ref$color,
      _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'middle' : _ref$align,
      className = _ref.className,
      dataTest = _ref['data-test'],
      theme = _ref.theme;
  var componentTheme = useComponentTheme({
    name: 'List',
    theme: getThemeConfig(theme)
  });
  return /*#__PURE__*/React.createElement(ListUl, {
    className: className,
    "data-test": dataTest ? dataTest : undefined
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ListLi, {
      key: index,
      "data-test": dataTest ? "".concat(dataTest, "-listitem-").concat(index) : undefined
    }, /*#__PURE__*/React.createElement(ListItemContent, {
      customTheme: componentTheme,
      color: color,
      align: align,
      type: "bullet"
    }, typeof item !== 'string' ? isItemWithSublist(item) ? item.listItem : item : item), typeof item !== 'string' && isItemWithSublist(item) && item.sublist && /*#__PURE__*/React.createElement(ListUl, {
      withPadding: true,
      "data-test": "".concat(dataTest, "-listitem-").concat(index, "-sublist")
    }, item.sublist.map(function (item, index) {
      return /*#__PURE__*/React.createElement(ListLi, {
        key: index,
        "data-test": "".concat(dataTest, "-listitem-").concat(index, "-sublistitem-").concat(index)
      }, /*#__PURE__*/React.createElement(ListItemContent, {
        customTheme: componentTheme,
        isSublist: true,
        type: "circle"
      }, item));
    })));
  }));
};

List.displayName = 'List';
export default List;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/list/dist/esm/variants/List.js
// module id = 4049
// module chunks = 11